import { AppointmentsService } from './../appointments.service';
import { Component, OnInit } from '@angular/core';
import { SettingsService } from '../settings.service';
import { LoginService } from '../login.service';

@Component({
    selector: 'app-exams-names',
    templateUrl: './exams-names.component.html',
    styleUrls: ['./exams-names.component.scss'],
    standalone: false
})
export class ExamsNamesComponent implements OnInit {
  exams = [];
  customExams=[]
  newExam = {  Color: '', Length: '', examType: '',examName:'',LengthTwins:'', AutoIndex: null,users:'' ,minWeeks:'',maxWeeks:'',maxDays:'',minDays:'',custom:false,Private:false,Macabi:false,Clalit:false,Leumit:false,Meuhedet:false,IDF:false,selfAppointment:false,MacabiCode:[],ClalitCode:[],LeumitCode:[],MeuhedetCode:[],IDFCode:[],PrivateCode:[]};
  customNewExam = {  Price:'',Color: '', Length: '', examType: '', AutoIndex: null,users:'' ,minWeeks:'',maxWeeks:'',custom:true,Private:false,Macabi:false,Clalit:false,Leumit:false,Meuhedet:false,IDF:false,selfAppointment:false,MacabiCode:[],ClalitCode:[],LeumitCode:[],MeuhedetCode:[],IDFCode:[],PrivateCode:[]};
  addRoom=false
  showMultiManager: boolean = false;

  error=false
  clinicTemplates: any[] = [];

  constructor(public settingsService:SettingsService,public ls:LoginService) { }

  async ngOnInit() {
   this.getExams()
   if (this.ls.isUSG || this.ls.isGastro) {
     this.clinicTemplates = await this.settingsService.getClinicTemplates();
   }
  }

  onClinicTemplateChange(exam) {
    const template = this.clinicTemplates.find((t) => Number(t.ClinicTemplateID) === Number(exam.ClinicTemplateID));
    if (template && !exam.examName) {
      exam.examName = template.Title;
    }
  }

  hmoCodeList = ['Macabi','Clalit','Leumit','Meuhedet','IDF','Private'];

  async getExams() {
    const exams = await this.settingsService.getExams();
    exams.forEach(exam => {
      exam.users = exam.users
        ? exam.users.toString().split(',').map(Number).filter(Boolean)
        : [];
      this.hmoCodeList.forEach(hmo => {
        const key = hmo + 'Code';
        exam[key] = exam[key]
          ? exam[key].toString().split(',').map(s => s.trim()).filter(Boolean)
          : [];
      });
    });
    this.exams = exams
      .filter((exam) => !exam.custom)
      .sort((a, b) => (a.displayOrder !== null && b.displayOrder !== null ? a.displayOrder - b.displayOrder : 0));

    this.customExams = exams
      .filter((exam) => exam.custom)
      .sort((a, b) => (a.displayOrder !== null && b.displayOrder !== null ? a.displayOrder - b.displayOrder : 0));
  }
  

  
  compareById(a: any, b: any): boolean {
    return Number(a) === Number(b);
  }

  trackByIndex(index: number): number {
    return index;
  }

  // Ensures the per-HMO code field on an exam is an array and returns its reference.
  codeArr(row: any, hmo: string): string[] {
    const key = hmo + 'Code';
    if (!Array.isArray(row[key])) {
      row[key] = row[key]
        ? row[key].toString().split(',').map((s: string) => s.trim()).filter(Boolean)
        : [];
    }
    return row[key];
  }

  addCode(row: any, hmo: string): void {
    this.codeArr(row, hmo).push('');
  }

  removeCode(row: any, hmo: string, index: number): void {
    this.codeArr(row, hmo).splice(index, 1);
  }

  hmoTranslateKey(hmo: string): string {
    const map = {
      Private: 'appointments.gui.labels.Private',
      Macabi: 'appointments.gui.hmo.Macabi',
      Clalit: 'appointments.gui.hmo.Clalit',
      Leumit: 'appointments.gui.hmo.Leumit',
      Meuhedet: 'appointments.gui.hmo.Meuhedet',
      IDF: 'appointments.gui.selects.IDF',
    };
    return map[hmo] || hmo;
  }

  editExam(exam) {
    exam.isEditing = true;
  }

  async saveChanges(exam) {
    try {
      const result = await this.settingsService.updateExam(exam);
      if (result['status']=='ok') {
        this.error=false;
        exam.isEditing = false;

      }
    } catch (error) {
      console.error('Error during the update exam details:', error);
      this.error=true
    }
  }

  async deleteExam(exam){
    try {
      const result = await this.settingsService.deleteExam(exam);
      if (result['status']=='ok') {
        this.error=false;
        this.getExams()

      }
    } catch (error) {
      console.error('Error during the update exam details:', error);
      this.error=true
    }
  }

  async saveNewExam(exam) {
    try {
     if(exam.custom) {
      exam.examName=exam.ExamType
     }
    const result =await this.settingsService.saveNewExam(exam)
    if (result['status']=='ok') {
      this.error=false;
      this.newExam = {  Color: '', Length: '',LengthTwins:'', examType: '',examName:'',AutoIndex: null,users:'',minWeeks:null,maxWeeks:null ,maxDays:'',minDays:'',custom:false,Private:false,Macabi:false,Clalit:false,Leumit:false,Meuhedet:false,IDF:false,selfAppointment:false,MacabiCode:[],ClalitCode:[],LeumitCode:[],MeuhedetCode:[],IDFCode:[],PrivateCode:[]};
      this.customNewExam = {  Price:'',Color: '', Length: '', examType: '', AutoIndex: null,users:'' ,minWeeks:'',maxWeeks:'',custom:true,Private:false,Macabi:false,Clalit:false,Leumit:false,Meuhedet:false,IDF:false,selfAppointment:false,MacabiCode:[],ClalitCode:[],LeumitCode:[],MeuhedetCode:[],IDFCode:[],PrivateCode:[]};
      this.getExams()
      

    }
  } catch (error) {
    console.error('Error during the save New Exam', error);
    this.error=true
  }
  }


  getExamTypes(){
    return this.settingsService.getDefault()
  }

  isStageEnvironment(): boolean {
    return window.location.href.includes('stage');
  }

  checkIfAnyExamEditing(){
   const isEditing= this.exams.some((exam)=> exam.isEditing )
   const isEditingCustom= this.customExams.some((exam)=> exam.isEditing )
   return isEditing || isEditingCustom
  }

  async saveAll() {
    // Save changes for regular exams
    for (const exam of this.exams) {
      if (exam.isEditing) {
        await this.saveChanges(exam);
      }
    }
  
    // Save changes for custom exams
    for (const customExam of this.customExams) {
      if (customExam.isEditing) {
        await this.saveChanges(customExam);
      }
    }
  }

  // moveExam(fromIndex: number, toIndex: number): void {
  //   const examsCopy = [...this.exams];
  //   const [movedItem] = examsCopy.splice(fromIndex, 1);
  //   examsCopy.splice(toIndex, 0, movedItem);
  //   this.exams = examsCopy;
  // }

  orderExams(examIndex: number, direction: 'up' | 'down', custom = false) {
    let examsToUpdate = custom ? this.customExams : this.exams;
  
    if ((direction === 'up' && examIndex > 0) || (direction === 'down' && examIndex < examsToUpdate.length - 1)) {
      const swapIndex = direction === 'up' ? examIndex - 1 : examIndex + 1;
      [examsToUpdate[examIndex], examsToUpdate[swapIndex]] = [examsToUpdate[swapIndex], examsToUpdate[examIndex]];
  
     
      examsToUpdate[examIndex].displayOrder = examIndex;
      examsToUpdate[swapIndex].displayOrder = swapIndex;
      this.saveOrderToDB(custom);
    }
  }
  
  saveOrderToDB(custom = false) {
    const examsToSave = custom ? this.customExams : this.exams;
    this.settingsService.updateExamOrder(examsToSave).subscribe(
      response => {
        console.log('Order saved successfully:', response);
      },
      error => {
        console.error('Error saving order:', error);
      }
    );
  }
  

}
